module.exports = __webpack_public_path__ + "img/extended.723a4274.png";